import React from 'react';
import ImpressionsCard from './kpi/ImpressionsCard';
import ClicksCard from './kpi/ClicksCard';
import CTRCard from './kpi/CTRCard';
import AvgPositionCard from './kpi/AvgPositionCard';
import SpikeDaysCard from './kpi/SpikeDaysCard';
import TopQueryCard from './kpi/TopQueryCard';

// Bento grid plan: 6 cards → grid-cols-3 2×3
// Row 1: Impressions (spans 2 cols — hero), Clicks (1 col)
// Row 2: CTR (1 col), Avg Position (1 col), Spike Days (1 col) [warning state]
// Row 3: Top Query (spans 3 cols — full width)
// Final: 6 cards, no orphans

export default function KPIBentoGrid() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-4">
      {/* Row 1 */}
      <div className="lg:col-span-2">
        <ImpressionsCard />
      </div>
      <div className="lg:col-span-1">
        <ClicksCard />
      </div>

      {/* Row 2 */}
      <div className="lg:col-span-1">
        <CTRCard />
      </div>
      <div className="lg:col-span-1">
        <AvgPositionCard />
      </div>
      <div className="lg:col-span-1">
        <SpikeDaysCard />
      </div>

      {/* Row 3 — full width */}
      <div className="lg:col-span-3">
        <TopQueryCard />
      </div>
    </div>
  );
}